export default {
    CALENDAR_ENTRIES_TABLE_NAME: process.env.REACT_APP_CALENDAR_ENTRIES_TABLE_NAME || "Team Calendar - Test",
    TRAINING_EVENTS_TABLE_NAME: process.env.REACT_APP_TRAINING_EVENTS_TABLE_NAME || "Training Program Beta",
    DISABLE_EMAIL_NOTIFICATIONS: process.env.REACT_APP_DISABLE_EMAIL_NOTIFICATIONS === "true" || false,
};
